module.exports = __webpack_public_path__ + "img/photo_profil_nico_linkedin.fbd87fe6.jpg";